import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import ReactModal from 'react-modal';

import type * as statuses from 'services/store/states';
import { getUserInfos } from 'services/store/features/User/actions';
import styles from './DownloadInvoice.module.css';
import Button from 'components/library/Button/Button';
import PaymentDetails from 'components/PaymentDetails';
import NotOwnerModal from 'components/NotOwnerModal/NotOwnerModal';

import EndModal from './Modal';
import type { AppDispatch } from 'services/store/types';

interface Props {
  actions: {
    getDownloadInvoice: () => void;
  },
  status: typeof statuses[keyof typeof statuses];
  isOwner?: boolean;
}

export default function DownloadInvoice({
  actions, status, isOwner,
}: Props) {
  const { t } = useTranslation();
  const dispatch: AppDispatch = useDispatch();

  const [isOpen, setIsOpen] = useState(false);

  const handleDownload = () => {
    actions.getDownloadInvoice();
  };

  useEffect(() => {
    if (status === 'IDLE') dispatch(getUserInfos());
  }, [status]);

  return (
    <>
      <section className={styles.content}>
        <div className={styles.grid}>
          <div className={styles.mobile}>
            <PaymentDetails />
          </div>
          <div className={styles.flexBox}>
            <h1 className={styles.icon}><span className={`${styles.materialIcons} material-icons`}>check_circle</span></h1>
            <h3 className={styles.title}>{t('downloadInvoice.title')}</h3>
            <p className={styles.subTitle}>{t('downloadInvoice.subTitle')}</p>
            <div className={styles.desktop}>
              <PaymentDetails />
            </div>
            <Button
              className={styles.downloadButton}
              variant="fill"
              label={t('downloadInvoice.downloadButton')}
              onButtonClick={handleDownload}
            />
            <Button
              variant="fill"
              type="secondary"
              label={t('downloadInvoice.submit')}
              onButtonClick={() => setIsOpen(true)}
            />
          </div>
        </div>
        <ReactModal
          isOpen={isOpen}
          className={`${styles.modal}`}
          overlayClassName={styles.modalOverlay}
          ariaHideApp={false}
        >
          <EndModal />
        </ReactModal>
      </section>
      {(isOwner === false) && (<NotOwnerModal />)}
    </>
  );
}
